import computed from './attrs/computed'
import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import watch from './attrs/watch'
import ViewIntro from '../../components/ViewIntro'

export default {
  name: 'Subscriptions',
  computed,
  data,
  methods,
  mounted,
  watch,
  components: {
    ViewIntro,
  },
}
